import React from "react"
import Button from "components/Button"
import ModalButtons from "components/ModalButtons"
import LabelValue from "components/LabelValue"
import Textfield from "inputs/Textfield"
import { dipRequest } from "data/dip/api"
import withForm from "hoc/withForm"
import withModal from "hoc/withModal"
import { stringRequired } from "validators/string"
import * as R from "ramda"

const CheckUpdateTaModal = ({ close, report, taxAccount }) => (
  <>
    <LabelValue mb={20} label="Filing entity name" value={report.entityName} />
    <LabelValue mb={20} label="Account name" value={taxAccount.accountName} />
    <LabelValue mb={20} label="Filing entity ID" value={taxAccount.elster ?? taxAccount.bop ?? report.entityId} />
    <LabelValue mb={20} label="Account type" value={taxAccount.elster ? "Elster" : taxAccount.bop ? "BOP" : "N/A"} />
    <Textfield required width={130} name="pin" label="PIN" type="password" />
    <ModalButtons>
      <Button secondary type="button" onClick={close} text="Cancel" />
      <Button type="submit" text="Check updates from TA" />
    </ModalButtons>
  </>
)

export default R.compose(
  withModal(R.always("Check udpates from TA")),
  withForm({
    schema: R.always({
      pin: stringRequired,
    }),
    onSubmit: p => v => dipRequest.updateStatus(p.reportId, v),
    onSuccess: p => () => {
      p.close()
      p.refetch()
    },
    successText: () =>
      R.always(
        "Request to update the report was sent. It will be processed in a few minutes.",
      ),
  }),
)(CheckUpdateTaModal)
